import { render, staticRenderFns } from "./DwdcblrEdit.vue?vue&type=template&id=3b70e493"
import script from "./DwdcblrEdit.vue?vue&type=script&lang=js"
export * from "./DwdcblrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports